import "./styles.scss";

import { useState } from "react";
import { useTranslation } from "react-i18next";

import ModalNew from "components/ModalNew";
import Button from "components/Button";

const mainClass = "delete-account-modal";

const DeleteAccountModal = ({ title, isOpen, onSubmit, onClose }) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      setLoading(true);

      if (typeof onSubmit === "function") await onSubmit();

      onClose();
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  return (
    <ModalNew
      title={t("Delete account")}
      variant="delete"
      loading={loading}
      hasMobileScrollTop={false}
      isOpen={isOpen}
      isSubmitHidden
      onClose={onClose}
    >
      <div className={mainClass}>
        <p>
          {t("Are you sure you want to delete the account of")} "
          <strong>{title}</strong>"? <u>{t("This action cannot be undone")}</u>.
        </p>
        <div className={`${mainClass}__cta`}>
          <Button onClick={handleSubmit}>{t("Delete")}</Button>
        </div>
      </div>
    </ModalNew>
  );
};

export default DeleteAccountModal;
